import FileDownload from "@mui/icons-material/FileDownload";
import { Button } from "@mui/material";
import Papa from "papaparse";
import { type FC, type MouseEventHandler, useCallback, useState } from "react";
import toast from "react-hot-toast";
import type { UUID } from "../../../../utils/uuid";
import { serveCsv } from "../../utils/serve-csv";
import { useAllMomentStats } from "../hooks/use-all-moment-stats";

export const AnalyticsExportButton: FC<{ disabled: boolean; moment_id: UUID }> = ({
  disabled,
  moment_id,
}) => {
  const [loading, setLoading] = useState(false);

  const allMomentStats = useAllMomentStats({ id: moment_id });

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await allMomentStats?.load();
      if (!data) return;

      serveCsv(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Papa.unparse(data.map(({ account_id, ...rest }) => rest)),
        `moment-analytics-${moment_id}-${new Date().toISOString()}.csv`,
      );
    } catch (e) {
      toast.error("Failed to export Communication analytics");
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [allMomentStats, moment_id]);

  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      e.stopPropagation();
      void loadData().catch(console.error);
    },
    [loadData],
  );

  if (!allMomentStats) return null;

  return (
    <Button
      data-analytics-id="export-moment-analytics"
      loading={loading}
      onClick={handleClick}
      color="primary"
      disabled={disabled}
      variant="text"
      startIcon={<FileDownload />}
    >
      Export
    </Button>
  );
};
